export const INSIGHTS_PAGE_LIMIT = 50;
